import { Box, Tooltip, Typography, styled, tooltipClasses } from "@mui/material";

export const PopoverBox = styled(Box)(({ theme}) => ({
    
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90%',
          height: '90%',
          backgroundColor: '#fff',
          border: '0.2rem solid #002277',
          boxShadow: 24,
          px: 3,
          overflow: 'auto',
       
}))

export const CustomScrollableTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: 'white',
      maxWidth: 600,
      boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
      padding: '1em',
      maxHeight: 300,
      overflowY: 'auto'
    },
  });

  export const MenuPopOverContent = ({ MenuPopoverData }) => {
    return (
      <Typography variant='p' sx={{ whiteSpace: 'pre-wrap', color: '#002277', fontSize: '1.2em' }}>{MenuPopoverData}</Typography>
    )
  }